export enum PatientMigrationStatus {
  NOT_ELIGIBLE = 'NOT_ELIGIBLE',
  NOT_MIGRATED = 'NOT_MIGRATED',
  MIGRATED = 'MIGRATED'
}